module.exports = __webpack_public_path__ + "img/96.4.NH3-N.f0530b16.png";